import axiosInstance from "../../services/axiosInstance";

import { useQuery } from 'react-query';

const fetchExchangeRate = async () => {
    const response = await axiosInstance.get("/exchange-rate/get");
    return response.data?.result;
};
export const useExchangeRateQuery = () => {
    return useQuery(['exchangeRate'], () => fetchExchangeRate(), {
        staleTime: 1000 * 60 * 10, // 10 minutes
    });
};